module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_BrightHoveAlbion.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_BrightHoveAlbion.png
// module id = 2077
// module chunks = 4